module.exports = __webpack_public_path__ + "img/template6_mobile.33324199.png";